import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 52563 55677"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:593.137}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g>
      <g id="_1974343009280">
        <path
          d="M29073 26554c58 1597-1274 3169-2991 2992-1716-179-2806-1451-2806-2912l74-2644 1761 11 2-1908c-1869-461-3011-1902-3103-3851-91-1949 542-2409 1472-3291l40-3688 5444-27-58 3637c-26 0 1435 1165 1435 3208 0 2045-1333 3739-3088 4011l-1 1907 1812 18 7 2537zM16591 36095l607 82 847 267v-608h3085v7987h-3047l11-1786-1429 274c-643 124-1592-211-2108-615l-3259 10 22-4977 3249 56c322-385 1323-784 2022-690zM35745 36095l-607 82-847 267v-608h-3085v7987h3048l-12-1786 1429 274c643 124 1592-211 2109-615l3259 10-23-4977-3250 56c-321-385-1322-784-2021-690z"
          className="fill stroke1"
          style={{
            strokeWidth: 770.849,
          }}
        />
        <path
          d="M1373 1373h49817v52931H1373z"
          style={{
            fill: "none",
            // stroke: "#2b2a29",
            strokeWidth: 2746.18,
          }}
          className="stroke1"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
